import { createContext } from "react"

const UiStoreContext = createContext({})

export default UiStoreContext;